var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainContent db-page"},[_c('div',{staticClass:"top-control"},[_c('div',{staticClass:"tab-content"},[(_vm.renderComponent)?_c('div',{staticClass:"dashboard-hpo"},[_c('big-package-statistics')],1):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }